import React, {Fragment, useEffect, useRef, useState} from "react";
import {useHistory, useLocation} from "react-router-dom";
import { useLocalStorageNew } from "../hooks/useLocalStorageNew";
import styles from "../layouts/Layout.module.css";
import NavBarStyles from "./YuJaNavbar.module.css";
import {
    BUTTON,
    COLLAPSED_SIDE_BAR_WIDTH,
    EXPANDED_SIDE_BAR_WIDTH, HOME_ICON,
    IDENTITY_PROVIDER_TYPES,
    MENU_LIST,
    NAVBAR_ENGAGE, RESPONSIVE_SIDE_BAR_POINT,
} from "../utils/constants";
import JoinPollModal from "./modals/JoinPollModal";
import WarningModal from "./modals/WarningModal";
import CollapsibleMenu from "./CollapsibleMenu";
import { ReactComponent as YuJaLogo } from "../images/yujalogo.svg";
import useWindowDimensions from "../hooks/useWindowDimensions";


export default function NewSidebar({ isMobile = false, collapsed, setCollapsed }) {
    const {width} = useWindowDimensions();
    const location = useLocation();
    const history = useHistory();
    const [, getSession] = useLocalStorageNew("session", {});
    const session = getSession();
    const { role = 'ANONYMOUS' } = session;
    const isEmbeddedFrame = (session.idpType && session.idpType === IDENTITY_PROVIDER_TYPES.LMS && window.location !== window.parent.location);
    const [code, setCode] = useState("");
    const [joinModalShow, setJoinModalShow] = useState(false);
    const [warningModalShow, setWarningModalShow] = useState(false);
    const sideBarContainerRef = useRef();

    const onClickLogo = () => {
        if (!!session.gradedLink) {
            return;
        }
        history.push("/home");
    }

    useEffect(() => {
        if (!isMobile) {
            return;
        }

        let btns = document.querySelectorAll(`[aria-label='Sidebar Panels'] [role='${BUTTON}']`);
        Array.from(btns).forEach((ele, idx) => {
           ele.tabIndex = collapsed ? "-1" : "0";
        });


    }, [isMobile, collapsed]);


    useEffect(() => {
        const handleKeydown = (event) => {
            if (event.key === 'Escape') {
                if (!collapsed && isMobile) {
                    setCollapsed(true);
                }
                event.preventDefault();
                return;
            }

            if (event.key !== "Tab" && event.key !== "ArrowUp" && event.key !== "ArrowDown") {
                return;
            }

            let container = document.querySelector("[aria-label='Sidebar Panels']");
            if (!(container instanceof HTMLElement)) {
                container = container.hasOwnProperty("dialog") ? container = container.dialog : null;
            }

            if (!container) {
                return;
            }

            let focusableElements = container.querySelectorAll('[tabindex]:not([tabindex="-1"]):not([disabled]), input:not([tabindex="-1"]):not([disabled])');

            focusableElements = Array.from(focusableElements).filter(el => {
                // Check if the element itself or any parent is hidden
                const style = window.getComputedStyle(el);
                return style.display !== 'none' && style.visibility !== 'hidden';
            });

            if (!container.contains(event.target)) {
                if (isMobile) {
                    event.preventDefault();
                    focusableElements[0].focus();
                }
                return;
            }

            if ((event.shiftKey && event.key === "Tab") || event.key  === "ArrowUp") {
                for (let i = 0; i < focusableElements.length; i++) {
                    if (focusableElements[i] !== event.target) {
                        continue;
                    }
                    if (i === 0 && event.shiftKey && event.key === "Tab" && !isMobile) {
                        return;
                    }
                    if (i === 0) {
                        event.preventDefault();
                        focusableElements[focusableElements.length - 1].focus();
                        return;
                    } else {
                        event.preventDefault();
                        focusableElements[i - 1].focus();
                        return;
                    }
                }
            } else {
                for (let i = 0; i < focusableElements.length; i++) {
                    if (focusableElements[i] !== event.target) {
                        continue;
                    }
                    if (i === focusableElements.length - 1 && event.key === "Tab" && !isMobile) {
                        return;
                    }

                    if (i === focusableElements.length - 1) {
                        event.preventDefault();
                        focusableElements[0].focus();
                        return;
                    } else {
                        event.preventDefault();
                        focusableElements[i + 1].focus();
                        return;
                    }
                }
            }

        };


        if (!collapsed) {
            document.addEventListener("keydown", handleKeydown);
        }


        return () => {
            document.removeEventListener("keydown", handleKeydown);
        };
    }, [collapsed, isMobile]);

    return (<>
        {width > RESPONSIVE_SIDE_BAR_POINT && !isMobile &&
            <nav
                aria-label={"Sidebar Panels"}
                ref={sideBarContainerRef}
                className={styles.sideBarContainer}
                style={{ width: (collapsed ? COLLAPSED_SIDE_BAR_WIDTH : EXPANDED_SIDE_BAR_WIDTH) }}
                onFocus={(e) => setCollapsed(false)}
                onBlur={(e) => {
                    if (!sideBarContainerRef.current.contains(e.relatedTarget)) {
                        setCollapsed(true);
                    }
                }}
                onMouseLeave={() => !collapsed ? setCollapsed(true) : undefined}
                onMouseEnter={() => collapsed ? setCollapsed(false) : undefined}
            >
                <ul style={{padding: 8, display: "flex", flexDirection: "column", gap: 5}}>
                        {Object.values(MENU_LIST).filter(menu => !menu.disabled).filter(menu => menu.roles.includes(role)).map((menu, idx) => (
                            <Fragment key={idx}>
                                {menu.hasOwnProperty("subStates") &&
                                    <CollapsibleMenu key={idx} menu={menu} sideBarCollapsed={collapsed} setSideBarCollapsed={setCollapsed}/>
                                }

                                {!menu.hasOwnProperty("subStates") &&
                                    <li style={{listStyle: "none"}}>
                                        <a
                                            tabIndex={0}
                                            aria-label={menu.name}
                                            id={`menu-link-${idx}`}
                                            onClick={() => history.push({pathname: menu.path})}
                                            className={`${(window.location.pathname === menu.path || (!!menu.parentPage && window.location.pathname.includes(menu.parentPage))) ? styles.activeSideBarLink : styles.sidebarLink}`}
                                            hidden={!menu.roles.includes(role)}
                                        >
                                            {!collapsed &&
                                                <div>
                                                    <img
                                                        id={`menu-icon-${menu.name}`}
                                                        src={(window.location.pathname === menu.path || (!!menu.parentPage && window.location.pathname.includes(menu.parentPage))) ? menu.activeIcon : menu.icon}
                                                        style={{width: "50px", height: "18px", marginRight: "5px"}}
                                                        alt={`${menu.name} icon`}
                                                        className={`${(window.location.pathname === menu.path || (!!menu.parentPage && window.location.pathname.includes(menu.parentPage))) ? styles.activeSubIcon : ""}`}
                                                    />
                                                    <span className={styles.sidebarText}>{menu.name}</span>
                                                </div>
                                            }
                                            {collapsed &&
                                                <div style={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    width: "100%"
                                                }}>
                                                    <img
                                                        id={`menu-icon-${menu.name}`}
                                                        src={(window.location.pathname === menu.path || (!!menu.parentPage && window.location.pathname.includes(menu.parentPage))) ? menu.activeIcon : menu.icon}
                                                        style={{height: "18px"}}
                                                        alt={`${menu.name} icon`}
                                                        className={`${(window.location.pathname === menu.path || (!!menu.parentPage && window.location.pathname.includes(menu.parentPage))) ? styles.activeSubIcon : ""}`}
                                                    />
                                                </div>
                                            }
                                        </a>
                                    </li>
                                }
                            </Fragment>
                        ))}
                    </ul>
            </nav>
        }
        {isMobile &&
            <div className={styles.sideBarContainerViewer} style={{ width: "240px" }}>
                <nav aria-label={"Sidebar Panels"} className={styles.sidebarMenu}>
                    {/*<FocusTrap setIsOpened={(val) => setCollapsed(!val)} isOpened={!collapsed}>*/}
                        <ul style={{padding: 10, display: "flex", flexDirection: "column", gap: 5}}>
                            <li className={styles.sidebarTitle} role={"presentation"} style={{justifyContent: "start", marginLeft: 0, gap: 5, height: "auto"}}>
                                <div
                                    tabIndex={0}
                                    aria-label={HOME_ICON}
                                    role={BUTTON}
                                    className={`${NavBarStyles.logoContainer} ${!session.gradedLink ? NavBarStyles.clickable : ""}`}
                                    onClick={onClickLogo}
                                >
                                    <YuJaLogo width={22} height={22}/>
                                </div>
                                <span className={NavBarStyles.pathContainer}>
                                    {NAVBAR_ENGAGE}
                                </span>
                            </li>
                            <li role={"separator"} className={styles.sidebarDivideLine} style={{listStyle: "none"}}/>
                            {Object.values(MENU_LIST).filter(menu => !menu.disabled).filter(menu => menu.roles.includes(role)).map((menu, idx) => (
                                <li key={idx} style={{listStyle: "none"}}>
                                    {menu.hasOwnProperty("subStates") &&
                                        <CollapsibleMenu key={idx} menu={menu} sideBarCollapsed={collapsed} setSideBarCollapsed={setCollapsed}/>
                                    }


                                    {!menu.hasOwnProperty("subStates") &&
                                        <a
                                            tabIndex={0}
                                            id={`menu-link-${idx}`}
                                            onClick={() => history.push({pathname: menu.path})}
                                            className={`${(window.location.pathname === menu.path || (!!menu.parentPage && window.location.pathname.includes(menu.parentPage))) ? styles.activeSideBarLink : styles.sidebarLink}`}
                                            hidden={!menu.roles.includes(role)}
                                        >

                                            <img
                                                id={`menu-icon-${menu.name}`}
                                                src={window.location.pathname === menu.path ? menu.activeIcon : menu.icon}
                                                style={{width: "50px", height: "18px", marginRight: "5px"}}
                                                alt={`${menu.name} icon`}
                                                className={`${window.location.pathname === menu.path ? styles.activeSubIcon : ""}`}
                                            />
                                            <span className={styles.sidebarText}>{menu.name}</span>

                                        </a>
                                    }
                                </li>
                            ))}
                        </ul>
                    {/*</FocusTrap>*/}
                </nav>
            </div>
        }
        <JoinPollModal
            code={code}
            setCode={setCode}
            modalShow={joinModalShow}
            setModalShow={setJoinModalShow}
            setWarningModalShow={setWarningModalShow}
        />
        {warningModalShow && <WarningModal
            show={warningModalShow}
            setModalShow={setWarningModalShow}
            code={code}
            usecase={"2"}
        />}
    </>)
};
